<app-storyboard-header [storyboard]="storyboard" (change)="change($event)"></app-storyboard-header>
<app-viewer-content *ngIf="file" [file]="file"></app-viewer-content>


